<section>
  <div class="alert alert-info d-flex flex-column justify-content-evenly" role="alert">
    <div><small><i aria-hidden="true" class="text-danger fas fa-exclamation-triangle fa-1x me-2"></i> <strong class="text-danger">REMINDER: Changed field division group info?</strong> Update the user import template, if applicable and then upload.</small></div>
    <div><small><i aria-hidden="true" class="fas fa-info-circle fa-1x me-2"></i> Once changes are committed, the  <strong>updates will be reflected in NESS automatically</strong> (no coordination with DBA or software release is required).</small></div>
  </div>
  <h2 class="h4">Manage Field Division Groups</h2>
  <p-messages></p-messages>
  <p-table #fdgroupsdt [value]="fieldDivisionGroups" [columns]="cols" dataKey="IntelligenceReportATFReferralGroupsID" editMode="row" [paginator]="true" [alwaysShowPaginator]="false" [rows]="rows" responsiveLayout="scroll" [autoLayout]="true" sortMode="single" [globalFilterFields]="['GroupName', 'ENESS_REF_FieldDivisions.FieldDivisionName','Inactive']" (onFilter)="onFilterFDGroups($event)">
    <ng-template pTemplate="caption">
      <div class="visually-hidden">Editable list of NESS field division groups</div>
      <div class="d-flex flex-wrap p-2">
        <button type="button" class="btn btn-success me-2 mb-2" (click)="addFieldDivisionGroupRow()" [disabled]="canAddEditFDGroup">Add field division group</button>
        <button type="button" class="btn btn-outline-medium-dark mx-2 mb-2" (click)="clear()" aria-label="Clear all field division group table filters and sorting." title="Clear all field division group table filters and sorting."><i class="pi pi-filter-slash" aria-hidden="true"></i> Clear</button>
        <div class="ms-lg-auto">
          <div class="input-group">
            <span class="input-group-text" aria-hidden="true"><i class="fa fa-search"></i></span>
            <input #filterInput type="text" placeholder="Filter field division groups" aria-label="Filter field division group table by field division, group name, and active status." (input)="fdgroupsdt.filterGlobal($event.target['value'], 'contains')" class="form-control">
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{ col.header }} <p-sortIcon title="Sort field division groups." [field]="col.field" ariaLabel="Activate to sort." ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
        <th scope="col" style="width: 8em">Action</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
      <tr [pEditableRow]="rowData">
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <select class="form-select" [(ngModel)]="rowData.FieldDivisionID" id="FieldDivisions" name="FieldDivisions" #FieldDivisions="ngModel" aria-label="Select the agency's field division." aria-required="true" [attr.aria-invalid]="!rowData.FieldDivisionID" required>
                <option value="">Select a field division</option>
                <ng-container *ngIf="fieldDivisions$ | async as fieldDivisions">
                  <option *ngFor="let fieldDiv of fieldDivisions" value="{{fieldDiv.FieldDivisionID}}">{{fieldDiv.FieldDivisionName}}</option>
                </ng-container>
              </select>
              <div class="invalid-feedback" *ngIf="FieldDivisions.invalid" role="alert">
                Please select a field division.
              </div>
            </ng-template>
            <ng-template pTemplate="output">
              {{rowData.ENESS_REF_FieldDivisions?.FieldDivisionName}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" class="form-control" [(ngModel)]="rowData.GroupName" id="GroupName" name="GroupName" #GroupName="ngModel" required>
              <div class="invalid-feedback" *ngIf="GroupName.invalid" role="alert">
                Please enter the field division group name.
              </div>
            </ng-template>
            <ng-template pTemplate="output">
              {{rowData.GroupName}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td style="width: 10rem">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-checkbox [(ngModel)]="rowData.Inactive" [value]="rowData.Inactive" inputId="Inactive" name="Inactive" [binary]="true" label="Is inactive?"></p-checkbox>
            </ng-template>
            <ng-template pTemplate="output">
              {{rowData.Inactive | booleanTransform: 'Inactive' :'Active'}}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="text-center">
          <button *ngIf="!editing" aria-label="Edit field division group row" pButton type="button" pInitEditableRow icon="pi pi-pencil" class="p-button-info" (click)="onRowEditInit(rowData)" [disabled]="canAddEditFDGroup" title="Edit field division group row"></button>
          <button *ngIf="editing" aria-label="Save field division group changes" pButton type="button" pSaveEditableRow icon="pi pi-check" class="p-button-success me-2" (click)="onRowEditSave(rowData, ri)" [disabled]="!rowData.FieldDivisionID || AppUtils.isEmptyInputValue(rowData.GroupName)" title="Save field division group changes"></button>
          <button *ngIf="editing" aria-label="Cancel field division group changes" pButton type="button" pCancelEditableRow icon="pi pi-times" class="p-button-danger" (click)="onRowEditCancel(rowData, ri)" title="Cancel field division group changes"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length + 1">
          No field division groups found.
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>
